import React from 'react'
import { useTranslation } from 'react-i18next'
import { Formik, Form } from 'formik'
import Box from '@mui/material/Box'
import LoadingButton from '@mui/lab/LoadingButton'
import Stack from '@mui/material/Stack'

import TextField from '@/components/formik/fields/TextField'

import { StepBaseProps } from '../types'

export type ConfigureCpsCardStepValues = {
  cps: string
}

export type ConfigureCpsCardStepProps = StepBaseProps & {
  onSubmit: (values: ConfigureCpsCardStepValues) => void
}

export function ConfigureCpsCardStep(props: ConfigureCpsCardStepProps) {
  const { confirmText, onSubmit } = props
  const { t } = useTranslation()

  return (
    <Box>
      <Formik initialValues={{ cps: '' }} onSubmit={onSubmit}>
        {({ isValid, handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <Stack spacing={4}>
              <TextField label={t('field.cps.label')} name="cps" />
              <LoadingButton disabled={!isValid} type="submit" variant="contained">{confirmText}</LoadingButton>
            </Stack>
          </Form>
        )}
      </Formik>
    </Box>
  )
}

export default ConfigureCpsCardStep